module.exports = __webpack_public_path__ + "assets/img/2a21faf9644f9e2055f098477abaf399.jpg";